var SupportGetawaysTonightStatusAndNotesPresentation;

SupportGetawaysTonightStatusAndNotesPresentation = {
  confirmed: {
    status: "Booked",
    notes: "Your reservation is scheduled for tonight. If you need immediate assistance, contact us at 888-963-3633 from 8 a.m. - 6 p.m. CT."
  },
  used: {
    status: "Reservation has passed"
  },
  failed: {
    status: "Problem charging your credit card"
  }
};

module.exports = SupportGetawaysTonightStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nZXRhd2F5c190b25pZ2h0X21lc3NhZ2VzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ByZXNlbnRlcnMvZ2V0YXdheXNfdG9uaWdodF9tZXNzYWdlcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxnREFBQSxHQUNDO0VBQUEsU0FBQSxFQUNDO0lBQUEsTUFBQSxFQUFRLFFBQVI7SUFDQSxLQUFBLEVBQVEsa0lBRFI7R0FERDtFQUdBLElBQUEsRUFDQztJQUFBLE1BQUEsRUFBUSx3QkFBUjtHQUpEO0VBS0EsTUFBQSxFQUNDO0lBQUEsTUFBQSxFQUFRLG1DQUFSO0dBTkQ7OztBQVFELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
